 <template>
 	<div class="pd-5">
     <div class="columns is-flex-wrap">
     	<div class="column is-10 mg-x-auto mg-t-20 ">
			<span class="fontbold2 has-text-dark is-size-4">Edit Profile </span>   
     	</div>
     	<div class="column is-10 mg-x-auto th">
	     	<div class="box-page is-flex-wrap columns">
	     		<div class="column is-3">
     				<div class=" is-flex is-hidden-tablet mg-b-5 is-align-end is-justify-end cursor" v-if="user.typeSystem == 'mentor'">
		    			<h3 @click="editProfile = !editProfile" class="has-text-weight-semibold has-text-right has-text-grey-lighter"><i class="fas fa-pen"></i> Edit</h3>
		    		</div>
			        <div id="preview" class="mg-b-5">
			          <label for="uploadfile">
			            <div class="circle-img" v-if="signup.profilePic != '' && signup.profilePic != null">
			               <img  class="haveimg" :src="getProfilePic(user.typeSystem)+signup.profilePic" />
			            </div>
			            <div v-if="signup.profilePic == ''" class="noimg">
			              <div class="font">170 x 170</div>
			              <div class="circle"></div>
			            </div>
			          </label>
			        </div>
			        <input style="display:none" v-if="user.typeSystem == 'mentor'"  type="file" id="uploadfile" name="uploadfile" @change="uploadFile($event,'profilePic')">
			        <div v-if="statusFile > 0 && editProfile == true" class="has-text-centered">
			          <span v-if="statusFile == 1" class="has-text-success">
			              <b-icon
			                icon="check"
			                pack="fas">
			              </b-icon> Upload Success
			          </span>
			          <span v-if="statusFile == 2" class="has-text-danger">
			            <b-icon
			              icon="times"
			              pack="fas">
			            </b-icon> Upload Fail
			          </span>
			        </div>
			        <div style="text-align:center" class="break-word">
			          <b-icon pack="fas"  icon="file-upload"  custom-class="fa-cloud-upload-alt mg-x-1 has-text-grey-dark"></b-icon>
			          <label for="uploadfile">{{signup.profilePic ? signup.profilePic : 'No file chosen' | snippetMid}}</label>
			        </div>
			    </div>
			    <div class="column is-9">
			    	<div class="columns is-flex-wrap">
			    		<div class="column is-9">
			    			<h3 class="has-text-weight-semibold is-size-4 has-text-dark is-flex is-align-end is-justify-start">Personal information</h3>
			    		</div>
			    		<div class="column is-hidden-mobile is-3 is-flex is-align-end is-justify-end cursor" v-if="user.typeSystem == 'mentor'">
			    			<h3 @click="editProfile = !editProfile" class="has-text-weight-semibold has-text-right has-text-grey-lighter"><i class="fas fa-pen"></i> Edit</h3>
			    		</div>
			    		<div class="column is-12 pd-0">
			    			<hr class="mg-0">
			    		</div>
			    		<div class="column is-6">
			    			<b-field label="Name" v-if="editProfile"> 
					            <b-input class="fontnormal" placeholder="Name" v-model="signup.name"></b-input>
					        </b-field>
					        <div v-else>
					        	Name: {{checkValueNoData(signup.name)}}
					        </div>
			    		</div>
			    		<div class="column is-6">
			    			<b-field label="Surname" v-if="editProfile"> 
					            <b-input class="fontnormal" placeholder="Surname" v-model="signup.surname"></b-input>
					        </b-field>
			    			<div v-else>
			    				Surname: {{checkValueNoData(signup.surname)}}
			    			</div>
			    		</div>
			    		<div class="column is-6">
			    			<b-field label="Position" v-if="editProfile"> 
					            <b-input class="fontnormal" placeholder="Position" v-model="position"></b-input>
					        </b-field>
					        <div v-else>
					        	Position: <span v-if="position != null">{{checkValueNoData(position)}}</span>
					        </div>
			    		</div>
			    		<div class="column is-6">
			    			<b-field label="Telephone of company" v-if="editProfile" >
					        	<VuePhoneNumberInput 
				                    v-model="phoneNumberDetailUser" 
									@update="updateNumberPhoneDetailUser"
				                    no-validator-state
				                    :default-country-code="(typeof signup.objectTelephoneNumber != 'undefineted' && signup.objectTelephoneNumber != null )?signup.objectTelephoneNumber.countryCode:''"
			                	/>
		               		</b-field>
		               		<div v-else>
					        	Telephone Number: <span v-if="signup.telephone != null">{{checkValueNoData(signup.telephone)}}</span>
					        </div>
				    	</div>
			    		<div class="column is-6">
			    			<b-field label="E-mail" v-if="editProfile"> 
					            <b-input disabled class="fontnormal" placeholder="E-mail" v-model="signup.email"></b-input>
					        </b-field>
			    			<div v-else>
			    				E-mail: <span v-if="signup.email != null">{{checkValueNoData(signup.email)}}</span>
			    			</div>
			    		</div>
			    		<div class="column is-12 pd-0" v-if="editProfile">
				        <div class="mg-x-auto">
				        	<div class="buttons ">
				        		<b-button type="is-dark" @click="editProfile = false" class="mg-l-auto">Cancel</b-button>
					          <a @click="saveData()"  class="mg-l-2 button buttonc pd-x-5">
					            <span class="">Save</span>
					          </a>
					        </div>
				        </div>  
				    </div>
			    	</div>
			    </div>
		    </div>
        </div>
     	<div class="column is-10 mg-x-auto th">
			<div class="box-page mg-t-30 is-flex-wrap columns">
				<div class="column is-3">
				<div class="column is-flex is-align-end is-hidden-tablet is-justify-end cursor" v-if="user.typeSystem == 'mentor'">
					<h3 @click="editBusiness = !editBusiness" class="has-text-weight-semibold has-text-right has-text-grey-lighter"><i class="fas fa-pen"></i> Edit</h3>
				</div>
				<div id="preview" class="mg-b-5">
					<label for="uploadLogo">
						<div class="circle-img" v-if="businessData.organizeLogo != '' && businessData.organizeLogo != null">
						<img  class="haveimg" :src="getProfilePic(user.typeSystem)+businessData.organizeLogo" />
						</div>
						<div v-if="businessData.organizeLogo == '' || businessData.organizeLogo == null" class="noimg">
						<div class="font">170 x 170</div>
						<div class="circle"></div>
						</div>
					</label>
				</div>
					<input style="display:none" v-if="user.typeSystem == 'mentor'" type="file" id="uploadLogo" name="uploadLogo" @change="uploadFileLogo($event,'organizeLogo')">
				<div v-if="statusFileLogo > 0" class="has-text-centered">
				<span v-if="statusFileLogo == 1" class="has-text-success">
						<b-icon icon="check" pack="fas"></b-icon> Upload Success
					</span>
					<span v-if="statusFileLogo == 2" class="has-text-danger">
						<b-icon
						icon="times"
						pack="fas">
						</b-icon> Upload Fail
					</span>
					</div>
					<div style="text-align:center">
					<b-icon pack="fas"  icon="file-upload"  custom-class="fa-cloud-upload-alt mg-x-1 has-text-grey-dark"></b-icon>
					<label for="uploadLogo">{{businessData.organizeLogo ? businessData.organizeLogo : 'No file chosen' | snippetMid}}</label>
					</div>
				</div>
				<div class="column is-9">
					<div class="columns is-flex-wrap">
						<div class="column is-9">
							<h3 class="has-text-weight-semibold is-size-4 has-text-dark is-flex is-align-end is-justify-start">Business information</h3>
						</div>
						<div class="column is-3 is-flex is-hidden-mobile is-align-end is-justify-end cursor" v-if="user.typeSystem == 'mentor'">
								<h3 @click="editBusiness = !editBusiness" class="has-text-weight-semibold has-text-right has-text-grey-lighter"><i class="fas fa-pen"></i> Edit</h3>
							</div>
						<div class="column is-12 pd-0">
							<hr class="mg-0">
						</div>
						<div class="column is-6 ">
							<b-field label="Type of business" v-if="editBusiness">
								<b-select placeholder="Type of business" expanded v-model="businessData.typeOfBusiness">
									<option  v-for="data in typeofbusiness" :value="data.index">{{data.name}}</option>
								</b-select>
							</b-field>
							<div v-else>
								Type of business: {{checkValueNoData(nameTypeOfBusiness(businessData.typeOfBusiness))}}
							</div>
						</div>
						<div class="column is-6 ">
							<b-field label="Name of company" v-if="editBusiness">
								<b-input class="fontnormal" placeholder="Name of company" v-model="businessData.nameOfBusiness"></b-input>
							</b-field>
							<div v-else>
								Name of company: {{checkValueNoData(businessData.nameOfBusiness)}}
							</div>
						</div>
						<div class="column is-6 ">
							<div v-if="editBusiness">
								<b-field label="Telephone of company" v-if="editBusiness">
								<VuePhoneNumberInput 
									v-model="phoneNumber" 
									@update="updateNumberPhone"
									no-validator-state
									:default-country-code="(businessData.typeCountryPhone != null && typeof businessData.typeCountryPhone.countryCode != 'undefineted')?businessData.typeCountryPhone.countryCode:''"
								/>
							</b-field>
							</div>
							<div v-else>
								Telephone of company: {{checkValueNoData(businessData.telephoneCompany)}}
							</div>
						</div>
						<div class="column is-6 ">
							<b-field label="Business website" v-if="editBusiness">
								<b-input class="fontnormal" placeholder="Business website" v-model="businessData.websiteBusiness"></b-input>
							</b-field>
							<div v-else>
								Business website: {{checkValueNoData(businessData.websiteBusiness)}}
							</div>
						</div>
						<div class="column is-6">
							<b-field label="Address" v-if="editBusiness">
								<b-input class="fontnormal" placeholder="Address" v-model="businessData.address"></b-input>
							</b-field>
							<div v-else>
								Address: {{checkValueNoData(businessData.address)}}
							</div>
						</div>
						<div class="column is-6">
							<b-field label="Sub-district" v-if="editBusiness">
								<b-input class="fontnormal" placeholder="Sub-district" v-model="businessData.subDistrict"></b-input>
							</b-field>
							<div v-else>
								Sub-district: {{checkValueNoData(businessData.subDistrict)}}
							</div>
						</div>
						<div class="column is-6">
							<b-field label="City/District" v-if="editBusiness">
								<b-input class="fontnormal" placeholder="City/District" v-model="businessData.cityDistrict"></b-input>
							</b-field>
							<div v-else>
								City/District: {{checkValueNoData(businessData.cityDistrict)}}
							</div>
						</div>
						<div class="column is-6">
							<b-field label="Province" v-if="editBusiness">
								<b-input class="fontnormal" placeholder="Province" v-model="businessData.province"></b-input>
							</b-field>
							<div v-else>
								Province: {{checkValueNoData(businessData.province)}}
							</div>
						</div>
						<div class="column is-6">
							<b-field label="Country" v-if="editBusiness">
								<b-input class="fontnormal" placeholder="Country" v-model="businessData.country"></b-input>
							</b-field>
							<div v-else>
								Country: {{checkValueNoData(businessData.country)}}
							</div>
						</div>
						<div class="column is-6">
							<b-field label="Postcode" v-if="editBusiness">
								<b-input class="fontnormal" placeholder="Postcode" v-model="businessData.postcode"></b-input>
							</b-field>
							<div v-else>
								Postcode: {{checkValueNoData(businessData.postcode)}}
							</div>
						</div>
						<div class="column is-12 pd-0" v-if="editBusiness">
							<div class="mg-x-auto mg-y-3">
				        	<div class="buttons ">
				        		<b-button type="is-dark" @click="editProfile = false" class="mg-l-auto">Cancel</b-button>
					          <a @click="saveData()"  class="mg-l-2 button buttonc pd-x-5">
					            <span class="">Save</span>
					          </a>
					        </div>
				        </div>  
						</div>
					</div>
				</div>
				
			</div>
       </div>
     </div>
    </div>
 </template>
 
<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import {HTTP,HTTPMentor,HTTPTicket} from "@/axios.js";
// import navbar from './navbar'
export default {
		components:{
			VuePhoneNumberInput
		},
        data() {
            return {
            	editProfile:false,
            	editBusiness:false,
				statusFile:0,
                signup:{
					name:'',
					surname:'',
					email:'',
					profilePic:'',
					telephone:'',
					objectTelephoneNumber:''
                },
                statusFileLogo:0,
             	businessData : {
			        typeOfBusiness:'',
			        nameOfBusiness:'',
					telephoneCompany:'',
					typeCountryPhone:'',
			        websiteBusiness:'',
			        address:'',
			        subDistrict:'',
			        cityDistrict:'',
			        province:'',
			        country:'',
			        postcode:'',
			        organizeLogo:''
			    },
			    position:'',
				tems:null,
				file:{
					name:''
				},
				url:null,
				typeofbusiness:[],
				phoneNumber:'',
				phoneNumberDetailUser:''
            }
        },
        methods:{
			updateNumberPhone(payload){
				payload['value']= (payload.phoneNumber !== null)?payload.phoneNumber.replace(/\s/g, ''):''
				this.businessData.typeCountryPhone = payload
				this.businessData.telephoneCompany = payload.value
			},
			updateNumberPhoneDetailUser(payload){
				payload['value']= (payload.phoneNumber !== null)?payload.phoneNumber.replace(/\s/g, ''):''
				this.signup.objectTelephoneNumber = payload
				this.signup.telephone = payload.value
			},
        	getProfilePic(type){
		        let path = ''
		        if(type == 'mentor'){
		          path = process.env.VUE_APP_IMG_PROFILE
		        }else if(type == 'inteGreat'){
		          path = process.env.VUE_APP_IMG_PROFILE_INTEGREAT
		        }
		        console.log(type)
		        return path
		        console.log('path',path)
		    },
        	nameTypeOfBusiness(value){
        		if(value != ''){
	        		let data = this.typeofbusiness.filter(res=>{
	        			return res.index == value
	        		})
	        		console.log('nameTypeOfBusiness',data)
	        		if(data.length > 0){
	        			return data[0].name
	        		}else{
	        			return ''
	        		}	
        		}else{
        			return ''
        		}
        		
        		
        	},
        	fecthTypeOfbusiness(){
        		HTTPTicket.post('/api/get/type/of/business').then(res=>{
        			this.typeofbusiness = res.data.obj
        			console.log(res)
        		})
        	},	
        	saveData(){
        		let data ={
        			position:this.position,
        			detailUser:this.signup,
        			businessData:this.businessData
				}
				console.log('/update/account',data)
        		HTTPMentor.defaults.headers.common.Authorization = 'Bearer '+this.user.token
        		console.log('data',data)
        		HTTPMentor.post('/update/account',data).then(res =>{
        			console.log('/update/account',res)
        			if(res.data.success){
        				let business = {
        					key:'businessData',
        					value:res.data.obj.businessData
        				}
        				let position = {
        					key:'position',
        					value:res.data.obj.position
        				}
        				let detailUser = {
        					key:'detailUser',
        					value:res.data.obj.detailUser
        				}
        				this.$store.commit('updateUser',detailUser)
        				this.$store.commit('updateUser',position)
        				this.$store.commit('updateUser',business)
        				this.editProfile = false
        				this.editBusiness = false
        			}
        			
        		})
        	},
        	gopath(val){
				this.$router.push(val)
         	},
        	ModalSuccess() {
	       		this.$notification.open({
		            duration: 3000,
		            message: `Edit profile successful`,
		            position: 'is-bottom-right',
		            type: 'is-success company',
		            hasIcon: true,
		            iconPack:'fas',
		            icon:"check-square"
	          	})
        	},
        	uploadFileLogo(event,nameValue){
        		this.statusFileLogo = 0
	            console.log(nameValue);  
	            console.log('uploadFileLogo',event.target.files[0])
	            var formData = new FormData();
	            formData.append("file", event.target.files[0]);
	            HTTPMentor.post(`upload/profilePic/`,formData)
	            .then(res => {
	                console.log("upload/file", res);  
	                if (res.data.success){
	                		console.log("2");  
	                		this.businessData.organizeLogo =  res.data.obj
							this.statusFileLogo = 1
							this.saveData()
	                }else{
	                    this.statusFileLogo = 2
	                }
	            })
	            .catch(e => {
	                console.log("upload/file/error",e);
	                if (this.component.options.multiple === false) {
	                    this.statusFileLogo = 0
	                }
	            });
        	},
			uploadFile(event,nameValue){
	            this.statusFile = 0
	            var formData = new FormData();
	            formData.append("file", event.target.files[0]);
	            HTTPMentor.post(`upload/profilePic/`,formData)
	            .then(res => {
	                console.log("upload/file/profile", res);  
	                if (res.data.success){
	                		console.log("1");  
							this.signup.profilePic =  res.data.obj
							this.statusFile = 1
							//this.saveData()
	                }else{
	                    this.statusFile = 2
	                }
	            })
	            .catch(e => {
	                console.log("upload/file/error",e);
	                if (this.component.options.multiple === false) {
	                    this.statusFile = 0
	                }
	            });
			},
			checkValueNoData(input){
				if (input !== '' && input !== null && typeof input !== 'undefined') {
					return input
				}else{
					return '-'
				}
			}
        },
        computed:{
        	user(){
        		return this.$store.state.islogin
        	},
        	token(){
        		return this.$store.state.token
        	}
        },
        created(){
        	this.fecthTypeOfbusiness()

        	if(this.user.detailUser[0].name != null && this.user.detailUser[0].name != ''){
        		this.signup.name = this.user.detailUser[0].name 
        	}
        	if(this.user.detailUser[0].surname != null && this.user.detailUser[0].surname != ''){
        		this.signup.surname = this.user.detailUser[0].surname
        	}
        	if(this.user.detailUser[0].profilePic != null && this.user.detailUser[0].profilePic != ''){
        		this.signup.profilePic = this.user.detailUser[0].profilePic
        	}
        	if(this.user.detailUser[0].email != null && this.user.detailUser[0].email != ''){
        		this.signup.email = this.user.detailUser[0].email
			}
			if(typeof this.user.detailUser[0].objectTelephoneNumber !== 'undefined' && this.user.detailUser[0].objectTelephoneNumber != null && this.user.detailUser[0].objectTelephoneNumber != ''){
				this.signup.objectTelephoneNumber = this.user.detailUser[0].objectTelephoneNumber
				this.phoneNumberDetailUser = this.user.detailUser[0].objectTelephoneNumber.value
        	}else{
				this.signup.objectTelephoneNumber = ''
				this.phoneNumberDetailUser = ''
			}

        	if(this.user.detailUser[0].telephone != null && this.user.detailUser[0].telephone != ''){
        		this.signup.telephone = this.user.detailUser[0].telephone
        		
			}
        	if(typeof this.user.detailUser[0] !== 'undefined' && this.user.detailUser[0].position != null && this.user.detailUser[0].position != ''){
				
        		this.position = this.user.detailUser[0].position
        	}
        	if(this.user.businessData != null && this.user.businessData.typeOfBusiness != null && this.user.businessData.typeOfBusiness != ''){
        		
        		this.businessData.typeOfBusiness = this.user.businessData.typeOfBusiness
        	}
        	if(this.user.businessData != null && this.user.businessData.nameOfBusiness != null && this.user.businessData.nameOfBusiness != ''){
        		this.businessData.nameOfBusiness = this.user.businessData.nameOfBusiness
        	}
        	if(this.user.businessData != null && this.user.businessData.websiteBusiness != null && this.user.businessData.websiteBusiness != ''){
        		this.businessData.websiteBusiness = this.user.businessData.websiteBusiness
			}
			
        	if(this.user.businessData != null && this.user.businessData.typeCountryPhone !== 'undefined'){
				this.businessData.typeCountryPhone = this.user.businessData.typeCountryPhone
				this.phoneNumber =  (typeof this.user.businessData.typeCountryPhone !== 'undefined')?this.user.businessData.typeCountryPhone.value:this.user.businessData.telephoneNumber
			}else{
				this.businessData.typeCountryPhone = ''
				this.phoneNumber = ''
			}

			if(this.user.businessData != null && this.user.businessData.telephoneCompany != null && this.user.businessData.telephoneCompany != ''){
				this.businessData.telephoneCompany = this.user.businessData.telephoneCompany
			}
			
			if(this.user.businessData != null && this.user.businessData.telephoneNumber != null && this.user.businessData.telephoneNumber != ''){
				this.businessData.telephoneCompany = this.user.businessData.telephoneNumber
        	}
        	if(this.user.businessData != null && this.user.businessData.address != null && this.user.businessData.address != ''){
        		this.businessData.address = this.user.businessData.address
        	}	
        	if(this.user.businessData != null && this.user.businessData.subDistrict != null && this.user.businessData.subDistrict != ''){
        		this.businessData.subDistrict = this.user.businessData.subDistrict
        	}
        	if(this.user.businessData != null && this.user.businessData.cityDistrict != null && this.user.businessData.cityDistrict != ''){
        		this.businessData.cityDistrict = this.user.businessData.cityDistrict
        	}
        	if(this.user.businessData != null && this.user.businessData.province != null && this.user.businessData.province != ''){
        		this.businessData.province = this.user.businessData.province
        	}
        	if(this.user.businessData != null && this.user.businessData.country != null && this.user.businessData.country != ''){
        		this.businessData.country = this.user.businessData.country
        	}
        	if(this.user.businessData != null && this.user.businessData.postcode != null && this.user.businessData.postcode != ''){
        		this.businessData.postcode = this.user.businessData.postcode
        	}
        	if(this.user.businessData != null && this.user.businessData.organizeLogo != null && this.user.businessData.organizeLogo != ''){
        		this.businessData.organizeLogo = this.user.businessData.organizeLogo
        	}
        	if(this.user.businessData != null && this.user.businessData.nameOfBusiness != null && this.user.businessData.nameOfBusiness != ''){
        		this.businessData.nameOfBusiness = this.user.businessData.nameOfBusiness
        	}
		},

}
</script>


<style lang="scss"  scoped>
	$blue : rgb(13, 106, 202);
	$orange : #FFA800;
	$orange-top : rgb(254,147,13);
	$orange-bottom:  rgb(254,175,28);
	$purple-top: rgb(139,98,228);
	$purple-bottom: rgb(122,122,236);
	.circle-img{
		width:170px;
		height:170px;
		overflow:hidden;
		display:flex;
		border-radius: 100%;
		justify-content: center;
		align-content: center;
		margin-left:auto;
		margin-right:auto;
		box-shadow: 0px 5px 5px 0px rgba(237,237,237,1);
	}
	.circle-img img{
		max-width:100%;
	}
	.tems{
		position: relative;
		bottom: 5px
	}
	.orange,.tems{
		color: $orange;
	}
	.buttonc{
		border-radius: 5px;
	    color: #fe930d;
	    border: 1px solid #fe930d;
	    opacity: 1;
	    background: transparent;
	    background-color: transparent;
	}
	.buttonc:hover{
		border: 1px solid #fe930d;
		color:#fff;
		background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
	}
	.changesignin{
		margin-bottom: 2rem
	}
	.box-page{
		border: 1px solid #ebebeb;
	    border-radius: 5px;
	    background: white;
	    padding: 1.8rem;
	}
	div.control {
	    width: 100%;
	    display: inline-block;
	}
	#preview .noimg{
		position:relative;
	}
	#preview .noimg .font{
		position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)
	}
	#preview .noimg .circle{
		border-radius: 50%; height: 170px !important; width: 170px !important; background: rgba(0,0,0,0.25); margin: 0 auto;box-shadow: 0px 5px 5px 0px rgba(237,237,237,1);
	}
  /* preview */

 
</style>
